import { apiConfig } from 'core-lib/config/config';
import { postMethod } from 'core-lib/utils/apiV2';
import { getDefaultHeaders } from 'core-lib/utils/network';

export type ResponseType = {
  state: string;
  phoneNumber: number;
};

function serialize(data: any, phoneNumber: any): ResponseType {
  return {
    state: data.state,
    phoneNumber,
  };
}

export type BodyType = {
  phoneNumber: number;
};

export type ResendBodyType = {
  phone_number: string;
  state: string;
  medium: number;
};

export const sendOTP = async (
  reqBody: BodyType,
): Promise<{ response?: ResponseType; error?: any }> => {
  const url = `${apiConfig('user', 'v1')}/user/b2c/otp/send/`;
  const { response, error }: any = await postMethod({
    endPoint: url,
    body: {
      phone_number: String(reqBody.phoneNumber),
    },
    headers: getDefaultHeaders({
      deviceId: true,
    }),
  });
  if (response) {
    return { response: serialize(response?.data, reqBody.phoneNumber) };
  }
  if (error) return { error };
};

export const resendOTP = async (
  reqBody: ResendBodyType,
): Promise<{ response?: ResponseType; error?: any }> => {
  const url = `${apiConfig('user', 'v1')}/user/b2c/otp/resend/`;
  const { response, error }: any = await postMethod({
    endPoint: url,
    body: reqBody,
    headers: getDefaultHeaders({
      deviceId: true,
    }),
  });

  if (response) {
    return { response: serialize(response?.data, reqBody.phone_number) };
  }
  if (error) return { error };
};
